<template>
    <div class="layout-menu-wrap">
        <ElMenuItem
            v-if="!hasChildren"
            :index="item.name as string"
            :class="[(item.meta?.level ?? 0) >= 2 ? 'el-sub-menu-overlay--level-2-item' : '']"
            @click="routerGump(item)"
        >
            <i class="iconfont menu-icon" :class="item.meta?.icon"></i>
            <template #title>
                <span>{{ item.meta?.title }}</span>
            </template>
        </ElMenuItem>
        <ElSubMenu
            v-else
            :index="item.name as string"
            :class="[(item.meta?.level ?? 0) >= 2 ? 'el-sub-menu-overlay--level-2' : '']"
        >
            <template #title>
                <i class="iconfont menu-icon" :class="item.meta?.icon"></i>
                <span>{{ item.meta?.title }}</span>
            </template>
            <template v-for="child in item.children" :key="child.path">
                <ElPopover
                    v-if="child.meta!.level! >= 3 && child.children?.length"
                    placement="right-start"
                    trigger="hover"
                    :teleported="false"
                    popper-class="menu-options"
                    :content="child.meta?.title"
                    @show="showAndHideHandle(true, child.name as string)"
                    @hide="showAndHideHandle(false, child.name as string)"
                >
                    <template #reference>
                        <ElMenuItem
                            :id="child.name"
                            class="popover-menu"
                            :disabled="true"
                            :index="child.name as string"
                            :class="{ 'el-sub-menu-overlay--level-2-item': true, active: isActiveSubMenu(child) }"
                            @click.stop="noToPage()"
                        >
                            <template #title>
                                <i :class="child.meta?.icon" class="iconfont menu-icon"></i>
                                <span class="menu-item-wrap"
                                    >{{ child.meta?.title }}
                                    <ElIcon class="el-sub-menu__icon-arrow" :size="12"><ArrowDown /></ElIcon
                                ></span>
                            </template>
                        </ElMenuItem>
                    </template>
                    <template #default>
                        <ElMenuItem
                            v-for="ele in child.children"
                            :key="ele.path"
                            :index="ele.name as string"
                            @click="routerGump(ele)"
                        >
                            <template #title>
                                <i :class="ele.meta?.icon" class="iconfont menu-icon"></i>
                                <span>{{ ele.meta?.title }}</span>
                            </template>
                        </ElMenuItem>
                    </template>
                </ElPopover>
                <template v-else>
                    <MenuItem :index="child.name" :item="child" />
                </template>
            </template>
        </ElSubMenu>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { ArrowDown } from "@element-plus/icons-vue";
import { ElIcon, ElMenuItem, ElPopover, ElSubMenu } from "element-plus";
import MenuItem from "./menuItem.vue";

import type { MenuOptions } from "./useMenu";

const router = useRouter();
const route = router.currentRoute;
const props = defineProps<{
    item: MenuOptions; // 接收菜单项
}>();

// 判断是否有子菜单
const hasChildren = computed(() => props.item.children && props.item.children.length > 0);
const showAndHideHandle = (show: boolean, id: string) => {
    // 根据id 查找该元素下的el-sub-menu__icon-arrow 元素 添加style transform: rotateZ(180deg);
    const referenceRef = document.querySelector(`#${id}`) as HTMLElement;
    const elSubMenuIconArrow = document.querySelector(`#${id} .el-sub-menu__icon-arrow`) as HTMLElement;
    if (elSubMenuIconArrow) {
        elSubMenuIconArrow.style.transform = show ? "rotateZ(180deg)" : "";
    }
    if (referenceRef) {
        referenceRef.style!.background = show ? "#3c7cae4d" : "";
    }
};
const noToPage = () => {};
const routerGump = (item: MenuOptions): void => {
    if (item.name === "ContractManagement" || item.name === "WarehouseContract" || item.name === "SealManagement") {
        localStorage.setItem("formMenus", "1");
    }
    if (item.name) {
        router.push({ name: item.name });
    } else {
        router.push({ path: item.path });
    }
};
const isActiveSubMenu = (item: MenuOptions) => {
    return item.children?.some((child: MenuOptions) => child.name === route.value.name);
};
</script>

<style lang="scss" scoped>
/* 可以添加样式 */
.menu-icon {
    margin-right: 10px;
    margin-left: 5px;
}
.menu-item-wrap {
    position: relative;
    i {
        position: absolute;
        right: -29px;
    }
}
</style>

<style lang="scss">
.layout-menu-wrap {
    .el-sub-menu.is-active.is-opened > .el-sub-menu__title {
        font-weight: bold;
    }
    .el-sub-menu-overlay--level-2 .el-sub-menu__title,
    .el-sub-menu-overlay--level-2-item {
        padding-left: calc(
            var(--el-menu-base-level-padding) + var(--el-menu-level) * var(--el-menu-level-padding) + 8px
        ) !important;
    }
    .active {
        border-radius: 6px;
    }
}
.popover-menu.is-disabled {
    opacity: 1 !important;
    cursor: pointer !important;
}
.popover-menu.active {
    font-weight: 700 !important;
}
.menu-options {
    position: fixed !important;
    padding: 0 6px !important;
    background: linear-gradient(180deg, #2f4562 0%, #1c385c 100%) !important;
    .el-popper__arrow::before {
        background-color: #2f4562 !important;
        border-color: #2f4562 !important;
    }
    .el-menu-item {
        box-sizing: border-box;
        margin: 3px 0;
        border-radius: var(--el-menu-border-radius);
        border-left: 2px solid transparent;
        &.is-active {
            color: #1c5bff !important;
            background: #f5f7fa !important;
            border-color: #2143fc;
        }
        &:hover {
            color: #e8efff;
        }
    }
}
</style>
